import React from 'react'

/* Import CSS */
import './index.scss'

class FullScreenToggle extends React.Component {
	constructor( props ) {
		super( props )

		this.state = {
			isFullscreen: false
		}

		// this.toggleFullScreen = this.toggleFullScreen.bind(this);
	}

	toggleFullScreen = ( e, ref ) => {
		e.preventDefault();

		this.setState( prevState => ( {
			isFullscreen: ! prevState.isFullscreen
		} ) )

		const elem = document.documentElement;
		// Check if the FullScreen already active?
		if ( ( document.fullScreenElement !== undefined && document.fullScreenElement === null ) ||
			( document.msFullscreenElement !== undefined && document.msFullscreenElement === null ) ||
			( document.mozFullScreen !== undefined && ! document.mozFullScreen ) ||
			( document.webkitIsFullScreen !== undefined && ! document.webkitIsFullScreen ) ) {
			// Activate Full Screen View.
			if ( elem.requestFullScreen ) {
				elem.requestFullScreen();
			} else if ( elem.mozRequestFullScreen ) {
				elem.mozRequestFullScreen();
			} else if ( elem.webkitRequestFullScreen ) {
				elem.webkitRequestFullScreen( Element.ALLOW_KEYBOARD_INPUT );
			} else if ( elem.msRequestFullscreen ) {
				elem.msRequestFullscreen();
			}

			document.body.classList.add('stlst-fullscreen');
			setTimeout( function() {
				window.stlst_legacy.draw_responsive_handle(); 
			}, 250 );
		} else {
			// Disable Full Screen View.
			if ( document.cancelFullScreen ) {
				document.cancelFullScreen();
			} else if ( document.mozCancelFullScreen ) {
				document.mozCancelFullScreen();
			} else if ( document.webkitCancelFullScreen ) {
				document.webkitCancelFullScreen();
			} else if ( document.msExitFullscreen ) {
				document.msExitFullscreen();
			}

			document.body.classList.remove('stlst-fullscreen');

			setTimeout( function() {
				window.stlst_legacy.draw_responsive_handle(); 
			}, 250 );
		}
	}

	udpateBodyClass = ( e ) => {
		const state = document.fullScreen || document.mozFullScreen || document.webkitIsFullScreen;
		const event = state ? 'FullscreenOn' : 'FullscreenOff';

		if ( event == 'FullscreenOff' ) {
			body.removeClass( "stlst-fullscreen" );
		}

		if ( event == 'FullscreenOn' ) {
			body.addClass( "stlst-fullscreen" );
		}
	}

	componentDidMount() {
		window.addEventListener( 'webkitfullscreenchange mozfullscreenchange fullscreenchange', this.udpateBodyClass.bind( this ) );
	}
	componentWillUnmount() {
		window.removeEventListener( 'webkitfullscreenchange mozfullscreenchange fullscreenchange', this.udpateBodyClass.bind( this ) );
	}

	render() {
		return (
			<button type="button" aria-label="Full-screen"
				className="fullscreen-btn stlst-components-button stlst-components-icon-button"
				onClick={this.toggleFullScreen}
				data-active={ this.state.isFullscreen }
			><svg aria-hidden="true" role="img" focusable="false" className="dashicon dashicons-admin-generic" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><path d="M3 15.6L3 12C3 11.5 2.6 11 2 11 1.5 11 1 11.5 1 12L1 18C1 18.1 1 18.3 1.1 18.4 1.1 18.5 1.2 18.6 1.2 18.7 1.2 18.7 1.2 18.7 1.3 18.7 1.3 18.7 1.3 18.7 1.3 18.7 1.3 18.8 1.3 18.8 1.3 18.8 1.4 18.8 1.5 18.9 1.6 18.9 1.7 19 1.8 19 2 19L2 19 8 19C8.5 19 9 18.6 9 18 9 17.5 8.5 17 8 17L4.4 17 8.7 12.7C9.1 12.3 9.1 11.7 8.7 11.3 8.3 10.9 7.7 10.9 7.3 11.3L3 15.6ZM19 1.9C19 1.8 19 1.7 18.9 1.6 18.9 1.5 18.8 1.4 18.8 1.4 18.8 1.3 18.8 1.3 18.8 1.3 18.7 1.3 18.7 1.3 18.7 1.3 18.7 1.3 18.7 1.3 18.7 1.3 18.6 1.2 18.5 1.1 18.4 1.1 18.3 1.1 18.2 1 18.1 1L18.1 1 18 1 12 1C11.5 1 11 1.5 11 2 11 2.6 11.5 3 12 3L15.6 3 11.3 7.3C10.9 7.7 10.9 8.3 11.3 8.7 11.5 8.9 11.8 9 12 9 12.3 9 12.5 8.9 12.7 8.7L17 4.4 17 8C17 8.6 17.5 9 18 9 18.6 9 19 8.6 19 8L19 2 19 2C19 1.9 19 1.9 19 1.9Z" /></svg> Enable Full Screen</button>
		)
	}
}

export default FullScreenToggle;



// WEBPACK FOOTER //
// ./dev/stylist_parent/components/fullscreen-toggle/index.jsx